// Import dependencies
import initialiser from '../../utils/initialiser';

// Import utils
import { smoothScrollTo } from '../../utils';

class ScrollIndicator {
  constructor(config) {
    const { el, settings } = config;

    // Set root element
    this.container = el;

    // Set settings
    this.settings = settings;
  }

  // Initialisation Function - Called on each component instance intialisation
  init = () => {
    if (!this.container) return;

    // Call bind events
    this.bindEvents();
  };

  bindEvents = () => {
    this.container.addEventListener('click', () => {
      smoothScrollTo();
    });
  };
}

// Export component wrapped in initialiser utility
export default (settings) => initialiser(settings, ScrollIndicator);
